// @flow
import styled from 'styled-components';

import { CLARK_SECONDARY } from 'styles/colors';
import { FONT_WEIGHT_100, FONT_WEIGHT_400 } from 'styles/font-weight';
import { LINE_HEIGHT_COPY } from 'styles/line-height';
import { SPACING_LARGE } from 'styles/spacing';
import { TYPE_SCALE_F5 } from 'styles/type-scale';

export const BankSetupLinks = styled.div`
  margin-bottom: ${SPACING_LARGE};
`;

export const BoldText = styled.span`
  ${FONT_WEIGHT_400};
`;

export const SubmitInfoCopy = styled.h3`
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  ${TYPE_SCALE_F5};
  color: ${CLARK_SECONDARY};
  margin-bottom: ${SPACING_LARGE};
`;



// WEBPACK FOOTER //
// ./src/components/payer/bank-account-details-form/styles.js